/**
 * 설교 영상 상세 페이지
 *
 * 참고: YouTube API로 변경되면서 이 페이지는 더 이상 사용되지 않습니다.
 * 설교 영상은 SermonList에서 직접 YouTube 링크로 열립니다.
 */

import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { MainLayout } from '../../../../shared/components';
import styled from '@emotion/styled';
import { theme } from '../../../../shared/styles/theme';

const PageContainer = styled.div`
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.xxxl};
  text-align: center;
`;

const Message = styled.p`
  font-size: ${theme.fontSizes.lg};
  color: ${theme.colors.text};
  margin-bottom: ${theme.spacing.lg};
`;

const BackButton = styled.button`
  padding: ${theme.spacing.md} ${theme.spacing.xl};
  background-color: ${theme.colors.primary};
  color: white;
  border: none;
  border-radius: ${theme.borderRadius.md};
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${theme.colors.secondary};
  }
`;

export const SermonDetail: React.FC = () => {
  const { sermonType } = useParams<{ sermonType: string; id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    // 자동으로 리스트 페이지로 리다이렉트
    const timer = setTimeout(() => {
      navigate(`/sermon/${sermonType}`);
    }, 3000);

    return () => clearTimeout(timer);
  }, [sermonType, navigate]);

  const handleBack = () => {
    navigate(`/sermon/${sermonType}`);
  };

  return (
    <MainLayout>
      <PageContainer>
        <Message>
          설교 영상은 이제 YouTube에서 직접 재생됩니다.
          <br />
          잠시 후 목록 페이지로 이동합니다...
        </Message>
        <BackButton onClick={handleBack}>
          목록으로 돌아가기
        </BackButton>
      </PageContainer>
    </MainLayout>
  );
};
